import type { NextPage } from "next";
import Head from "next/head";
import Image from "next/image";
import styles from "../styles/Home.module.css";
import { Box } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import theme from "../styles/LLTheme";
import { useRouter } from 'next/router';
import { useRef } from 'react';
import "swiper/css";
import "swiper/css/effect-cards";
import Mobile from "../components/home/mobile";
import Feature from "../components/feature";
import Target from "../components/target";
import { useState } from "react";
import Landing from '../components/home/landing';
import Prallex from "../components/home/parallax";
import Footer2 from "../components/footer2";
import Download from "../components/download"
import Script from 'next/script'

const Home: NextPage = () => {

  return (
    <ThemeProvider theme={theme}>
      {/* <Box data-scroll-section> */}
      <Head>
        <title>lilico - The first flow extension wallet</title>
      </Head>
      <Script src="https://cdn.lordicon.com/pzdvqjsp.js"></Script>
      <div style={{ position: "absolute", width: "100vw", height: "200vh", }}>
        <Image
          src="/background.svg"
          alt="background"
          width="100%"
          height="100%"
          sizes="100vw"
          style={{
            position: "absolute",
            top: "0",
            right: "0",
            objectFit: "cover",
            objectPosition: "absolute"
          }} />
      </div>
      <div className={styles.container}>
        <Box
          component="main"
          sx={{
            minHeight: "100vh",
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#121212",
            // maxWidth: '80%'
          }}
        >
          <Landing/>
          <Target/>
          <Prallex/>
          <Feature/>
          {/* <Mobile/> */}
          <Download/>
          <Footer2/>
        </Box>
      </div>
    </ThemeProvider>
  );
};

export default Home;
